(function () {
  const DURATION = 400;
  const bars = document.querySelectorAll('[data-announcement-bar]');

  bars.forEach((bar) => {
    const messages = bar.querySelectorAll('[data-announcement-message]');
    if (messages.length < 2) return;

    const interval = parseInt(bar.dataset.interval, 10) || 5000;
    let index = 0;
    let animating = false;

    window.setInterval(() => {
      if (animating) return;
      animating = true;

      const current = messages[index];
      const nextIndex = (index + 1) % messages.length;
      const next = messages[nextIndex];

      current.classList.add('is-exiting');
      current.classList.remove('is-active');
      next.classList.add('is-active');

      window.setTimeout(() => {
        current.classList.add('is-no-transition');
        current.classList.remove('is-exiting');
        void current.offsetWidth;
        current.classList.remove('is-no-transition');

        index = nextIndex;
        animating = false;
      }, DURATION);
    }, interval);
  });

  const categoriesToggle = document.querySelector('[data-categories-toggle]');
  const categoriesPanel = document.querySelector('[data-categories-panel]');

  if (categoriesToggle && categoriesPanel) {
    const tabs = categoriesPanel.querySelectorAll('[data-categories-tab]');
    const panes = categoriesPanel.querySelectorAll('[data-categories-pane]');

    const setActiveTab = (index) => {
      tabs.forEach((tab) => {
        if (tab.dataset.categoriesIndex === index) {
          tab.classList.add('is-active');
        } else {
          tab.classList.remove('is-active');
        }
      });

      panes.forEach((pane) => {
        if (pane.dataset.categoriesIndex === index) {
          pane.classList.add('is-active');
        } else {
          pane.classList.remove('is-active');
        }
      });
    };

    const openPanel = () => {
      categoriesPanel.hidden = false;
      categoriesPanel.classList.add('is-open');
      categoriesToggle.classList.add('is-open');
      categoriesToggle.setAttribute('aria-expanded', 'true');
    };

    const closePanel = () => {
      categoriesPanel.hidden = true;
      categoriesPanel.classList.remove('is-open');
      categoriesToggle.classList.remove('is-open');
      categoriesToggle.setAttribute('aria-expanded', 'false');
    };

    const isPanelOpen = () => !categoriesPanel.hidden;

    categoriesToggle.addEventListener('click', (event) => {
      event.stopPropagation();
      if (isPanelOpen()) {
        closePanel();
      } else {
        openPanel();
      }
    });

    const nav = document.querySelector('.site-header__nav');
    if (nav) {
      nav.querySelectorAll('.site-header__nav-item:not(.site-header__nav-item--categories)').forEach((item) => {
        item.addEventListener('mouseenter', () => {
          if (isPanelOpen()) {
            closePanel();
          }
        });
      });
    }

    tabs.forEach((tab) => {
      tab.addEventListener('mouseenter', () => {
        setActiveTab(tab.dataset.categoriesIndex);
      });

      tab.addEventListener('focus', () => {
        setActiveTab(tab.dataset.categoriesIndex);
      });
    });

    document.addEventListener('click', (event) => {
      if (!isPanelOpen()) return;
      if (categoriesPanel.contains(event.target) || categoriesToggle.contains(event.target)) return;
      closePanel();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && isPanelOpen()) {
        closePanel();
        categoriesToggle.focus();
      }
    });
  }

  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const mobileMenuToggle = document.querySelector('[data-mobile-menu-toggle]');

  if (mobileMenu && mobileMenuToggle) {
    const mobileMenuCloseTargets = mobileMenu.querySelectorAll('[data-mobile-menu-close]');
    const submenuToggles = mobileMenu.querySelectorAll('[data-mobile-submenu-toggle]');

    const openMobileMenu = () => {
      mobileMenu.hidden = false;
      window.requestAnimationFrame(() => {
        mobileMenu.classList.add('is-open');
      });
      document.body.classList.add('mobile-menu-open');
      mobileMenuToggle.setAttribute('aria-expanded', 'true');
    };

    const closeMobileMenu = () => {
      mobileMenu.classList.remove('is-open');
      mobileMenuToggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('mobile-menu-open');

      window.setTimeout(() => {
        if (!mobileMenu.classList.contains('is-open')) {
          mobileMenu.hidden = true;
        }
      }, 300);
    };

    const isMobileMenuOpen = () => mobileMenu.classList.contains('is-open');

    mobileMenuToggle.addEventListener('click', () => {
      if (isMobileMenuOpen()) {
        closeMobileMenu();
      } else {
        openMobileMenu();
      }
    });

    mobileMenuCloseTargets.forEach((target) => {
      target.addEventListener('click', () => {
        closeMobileMenu();
      });
    });

    submenuToggles.forEach((trigger) => {
      const submenu = trigger.parentElement ? trigger.parentElement.nextElementSibling : null;

      if (!submenu || !submenu.matches('.mobile-menu__submenu, .mobile-menu__submenu-nested')) {
        return;
      }

      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

        if (isExpanded) {
          trigger.setAttribute('aria-expanded', 'false');
          trigger.classList.remove('is-open');
          submenu.hidden = true;
        } else {
          trigger.setAttribute('aria-expanded', 'true');
          trigger.classList.add('is-open');
          submenu.hidden = false;
        }
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && isMobileMenuOpen()) {
        closeMobileMenu();
        mobileMenuToggle.focus();
      }
    });
  }

  const showNewsletterSuccess = (form) => {
    const section = form.closest('[data-newsletter-section]');
    if (!section) return;

    const success = section.querySelector('[data-newsletter-success]');
    const title = section.dataset.successMessage || '';
    const description = section.dataset.successDescription || '';

    section.classList.add('newsletter--success');

    if (success) {
      const heading = success.querySelector('.newsletter__success-heading');
      const successDescription = success.querySelector('.newsletter__success-description');

      if (heading && title) {
        heading.textContent = title;
      }

      if (successDescription) {
        if (description) {
          successDescription.textContent = description;
          successDescription.style.display = '';
        } else {
          successDescription.style.display = 'none';
        }
      }

      section.scrollIntoView({ block: 'center' });

      if (heading) {
        heading.focus();
      }
    } else {
      section.scrollIntoView({ block: 'center' });
    }
  };

  const showNewsletterError = (form, text) => {
    let error = form.querySelector('[data-newsletter-error]');

    if (!error) {
      error = document.createElement('div');
      error.className = 'newsletter__message newsletter__message--error';
      error.setAttribute('data-newsletter-error', '');
      form.insertBefore(error, form.firstChild);
    }

    error.textContent = text;
  };

  const handleNewsletterHashSuccess = () => {
    const hash = window.location.hash.slice(1);
    if (!hash || hash.indexOf('NewsletterForm-') !== 0) return;

    const form = document.getElementById(hash);
    if (!form || !form.classList.contains('newsletter__form')) return;
    if (form.querySelector('.newsletter__message--error')) return;

    showNewsletterSuccess(form);

    const cleanUrl = new URL(window.location.href);
    cleanUrl.hash = '';
    window.history.replaceState({}, '', cleanUrl.pathname + cleanUrl.search);
  };

  document.querySelectorAll('[data-newsletter-section] .newsletter__form').forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();

      const section = form.closest('[data-newsletter-section]');
      const submitButton = form.querySelector('[data-newsletter-submit]');
      const consent = form.querySelector('.newsletter__consent-checkbox');
      const fallbackError = section ? section.dataset.errorMessage : '';

      if (consent && !consent.checked) {
        consent.reportValidity();
        return;
      }

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      if (submitButton) {
        submitButton.disabled = true;
      }

      fetch(form.action || '/contact', {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        headers: {
          Accept: 'text/html',
        },
      })
        .then((response) => response.text().then((html) => ({ response, html })))
        .then(({ response, html }) => {
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const responseError =
            parsed.querySelector('.newsletter__message--error') ||
            parsed.querySelector('.errors');

          if (responseError && responseError.textContent.trim()) {
            showNewsletterError(form, responseError.textContent.trim());
            return;
          }

          if (response.ok || response.redirected) {
            showNewsletterSuccess(form);
            return;
          }

          showNewsletterError(form, fallbackError);
        })
        .catch(() => {
          showNewsletterError(form, fallbackError);
        })
        .finally(() => {
          if (submitButton) {
            submitButton.disabled = false;
          }
        });
    });
  });

  handleNewsletterHashSuccess();

  const newsletterSuccessBlock = document.querySelector('.newsletter--success [data-newsletter-success]');
  const newsletterSection = document.querySelector('[data-newsletter-section].newsletter--success');
  const hasCustomerPosted = window.location.search.indexOf('customer_posted') !== -1;

  if (newsletterSuccessBlock || newsletterSection || hasCustomerPosted) {
    const target = newsletterSection || newsletterSuccessBlock;

    if (target) {
      window.requestAnimationFrame(() => {
        target.scrollIntoView({ block: 'center' });

        const heading = target.querySelector('.newsletter__success-heading');
        if (heading) {
          heading.focus();
        }
      });
    }

    if (hasCustomerPosted) {
      const cleanUrl = new URL(window.location.href);
      cleanUrl.searchParams.delete('customer_posted');
      window.history.replaceState({}, '', cleanUrl.pathname + cleanUrl.search + cleanUrl.hash);
    }
  }

  document.querySelectorAll('[data-trust-badges]').forEach((root) => {
    const track = root.querySelector('[data-trust-badges-track]');
    const viewport = root.querySelector('[data-trust-badges-viewport]');
    const pagination = root.querySelector('[data-trust-badges-pagination]');
    const pagesContainer = root.querySelector('[data-trust-badges-pages]');
    const prevButton = root.querySelector('[data-trust-badges-prev]');
    const nextButton = root.querySelector('[data-trust-badges-next]');
    const slides = root.querySelectorAll('[data-trust-badges-slide]');

    if (!track || !viewport || !pagination || !pagesContainer || !prevButton || !nextButton || slides.length === 0) {
      return;
    }

    let currentPage = 0;
    let totalPages = 1;
    let itemsPerPage = 4;
    const cardGap = 24;

    const getItemsPerPage = () => 4;

    const renderPages = () => {
      pagesContainer.replaceChildren();

      for (let index = 0; index < totalPages; index += 1) {
        const pageButton = document.createElement('button');
        pageButton.type = 'button';
        pageButton.className = 'trust-badges__page';
        pageButton.textContent = String(index + 1);

        if (index === currentPage) {
          pageButton.classList.add('is-active');
          pageButton.setAttribute('aria-current', 'true');
        }

        pageButton.addEventListener('click', () => {
          currentPage = index;
          updateCarousel();
        });

        pagesContainer.appendChild(pageButton);
      }
    };

    const updateCarousel = () => {
      if (window.matchMedia('(max-width: 1199px)').matches) {
        pagination.hidden = true;
        track.style.transform = 'translateX(0)';

        slides.forEach((slide) => {
          slide.style.flex = '';
        });

        return;
      }

      itemsPerPage = getItemsPerPage();
      totalPages = Math.max(1, Math.ceil(slides.length / itemsPerPage));

      if (currentPage >= totalPages) {
        currentPage = totalPages - 1;
      }

      const viewportWidth = viewport.offsetWidth;
      const gapTotal = cardGap * Math.max(itemsPerPage - 1, 0);
      const slideWidth = (viewportWidth - gapTotal) / itemsPerPage;

      slides.forEach((slide) => {
        slide.style.flex = `0 0 ${slideWidth}px`;
      });

      if (totalPages <= 1) {
        pagination.hidden = true;
        track.style.transform = 'translateX(0)';
        return;
      }

      pagination.hidden = false;
      prevButton.disabled = currentPage === 0;
      nextButton.disabled = currentPage === totalPages - 1;

      track.style.transform = `translateX(-${currentPage * viewportWidth}px)`;

      renderPages();
    };

    prevButton.addEventListener('click', () => {
      if (currentPage > 0) {
        currentPage -= 1;
        updateCarousel();
      }
    });

    nextButton.addEventListener('click', () => {
      if (currentPage < totalPages - 1) {
        currentPage += 1;
        updateCarousel();
      }
    });

    window.addEventListener('resize', () => {
      updateCarousel();
    });

    updateCarousel();
  });

  const footerDetails = document.querySelectorAll('.site-footer__details');
  const footerMedia = window.matchMedia('(min-width: 1200px)');

  if (footerDetails.length > 0) {
    const setFooterDetailState = (detail, isExpanded) => {
      const summary = detail.querySelector('.site-footer__summary');
      detail.classList.toggle('is-expanded', isExpanded);

      if (summary) {
        summary.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      }
    };

    const syncFooterDetails = () => {
      footerDetails.forEach((detail) => {
        detail.setAttribute('open', '');

        if (footerMedia.matches) {
          setFooterDetailState(detail, true);
        } else {
          setFooterDetailState(detail, false);
        }
      });
    };

    footerDetails.forEach((detail) => {
      const summary = detail.querySelector('.site-footer__summary');
      if (!summary) {
        return;
      }

      summary.addEventListener('click', (event) => {
        if (footerMedia.matches) {
          event.preventDefault();
          return;
        }

        event.preventDefault();

        const willExpand = !detail.classList.contains('is-expanded');

        footerDetails.forEach((item) => {
          setFooterDetailState(item, item === detail && willExpand);
        });
      });
    });

    syncFooterDetails();
    footerMedia.addEventListener('change', syncFooterDetails);
  }

  const TRACKING_PARAM_KEYS = [
    '_pos',
    '_sid',
    '_ss',
    '_su_rec',
    '_su_rec_id',
    'pr_prod_strat',
    'pr_rec_id',
    'pr_rec_pid',
    'pr_ref_pid',
  ];

  const hrefHasTrackingParams = (href) => {
    if (!href || typeof href !== 'string') {
      return false;
    }

    try {
      const url = new URL(href, window.location.origin);
      for (let index = 0; index < TRACKING_PARAM_KEYS.length; index += 1) {
        if (url.searchParams.has(TRACKING_PARAM_KEYS[index])) {
          return true;
        }
      }
    } catch (error) {
      return false;
    }

    return false;
  };

  const cleanProductHref = (href) => {
    if (!href || typeof href !== 'string') {
      return href;
    }

    let url;
    try {
      url = new URL(href, window.location.origin);
    } catch (error) {
      return href;
    }

    if (!url.pathname.includes('/products/')) {
      return href;
    }

    for (let index = 0; index < TRACKING_PARAM_KEYS.length; index += 1) {
      url.searchParams.delete(TRACKING_PARAM_KEYS[index]);
    }

    const query = url.searchParams.toString();
    if (query) {
      return `${url.pathname}?${query}`;
    }

    return url.pathname;
  };

  const isSearchResultsPath = (pathname) => {
    if (!pathname) {
      return false;
    }

    return pathname === '/search' || pathname.endsWith('/search');
  };

  const cleanLocationBar = () => {
    const url = new URL(window.location.href);
    let changed = false;

    for (let index = 0; index < TRACKING_PARAM_KEYS.length; index += 1) {
      const key = TRACKING_PARAM_KEYS[index];
      if (url.searchParams.has(key)) {
        url.searchParams.delete(key);
        changed = true;
      }
    }

    if (isSearchResultsPath(url.pathname) && url.searchParams.get('type') === 'product') {
      url.searchParams.delete('type');
      changed = true;
    }

    if (!changed) {
      return;
    }

    const next = url.pathname + url.search + url.hash;
    window.history.replaceState({}, '', next);
  };

  const LINK_SCOPE_SELECTORS = [
    '[data-search-page]',
    '[data-dl-item-list]',
    '.collection-page',
    '[data-product-showcase]',
  ];

  const cleanScopedProductLinks = () => {
    LINK_SCOPE_SELECTORS.forEach((selector) => {
      document.querySelectorAll(selector).forEach((root) => {
        root.querySelectorAll('a[href*="/products/"]').forEach((link) => {
          const raw = link.getAttribute('href');
          const cleaned = cleanProductHref(raw);
          if (cleaned && cleaned !== raw) {
            link.setAttribute('href', cleaned);
          }
        });
      });
    });
  };

  let linkCleanupTimer = null;

  const scheduleLinkCleanups = () => {
    cleanLocationBar();
    cleanScopedProductLinks();

    [250, 800, 2000].forEach((delay) => {
      window.setTimeout(() => {
        cleanLocationBar();
        cleanScopedProductLinks();
      }, delay);
    });
  };

  const debouncedLinkCleanup = () => {
    if (linkCleanupTimer) {
      window.clearTimeout(linkCleanupTimer);
    }

    linkCleanupTimer = window.setTimeout(() => {
      cleanScopedProductLinks();
      linkCleanupTimer = null;
    }, 80);
  };

  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest('a[href*="/products/"]');
      if (!link) {
        return;
      }

      const raw = link.getAttribute('href');
      if (!hrefHasTrackingParams(raw)) {
        return;
      }

      const cleaned = cleanProductHref(raw);
      if (!cleaned || cleaned === raw) {
        return;
      }

      event.preventDefault();
      window.location.assign(cleaned);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleLinkCleanups);
  } else {
    scheduleLinkCleanups();
  }

  if (document.body) {
    const linkObserver = new MutationObserver(() => {
      debouncedLinkCleanup();
    });

    linkObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['href'],
    });
  }

  document.addEventListener('joker:datalayer-list-updated', cleanScopedProductLinks);
})();
